export default __webpack_public_path__ + "static/media/13n.1ba06d44.png";